import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Accepting an organization invitation`}</h2>
    <p>{`If you receive an invitation to an organization, you have to accept the invitation over email to be added to the organization.`}</p>
    <p>{`You have the option to use a different email address than the one that received the invitation to join the organization.`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Click the verification link in the organization invitation email.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You will be prompted to log into your npm user account. If you don't have an npm user account, you can sign up for one.`}</p>
        <Screenshot src="/organizations/managing-organization-members/accept-invitation.png" alt="Accept organization invitation" mdxType="Screenshot" />
      </li>
    </ol>
    <h2>{`Rejecting an organization invitation`}</h2>
    <p>{`If you are invited to an organization that you do not want to join, you can let the invitation expire. Organization invitations expire after one week.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      